import React from 'react';
import { ConfigProvider } from 'antd';
import { theme as antdTheme } from 'antd';
import trTR from 'antd/locale/tr_TR';
import { useTheme } from '../contexts/ThemeContext';

const { darkAlgorithm, defaultAlgorithm } = antdTheme;

interface AntdThemeProviderProps {
  children: React.ReactNode;
}

/**
 * Ant Design bileşenlerinin (Card, Table, Form vb.) dark/light modda
 * doğru renklerle görünmesi için ConfigProvider ile tema uygular.
 */
export const AntdThemeProvider: React.FC<AntdThemeProviderProps> = ({ children }) => {
  const { theme } = useTheme();

  return (
    <ConfigProvider
      locale={trTR}
      theme={{
        algorithm: theme === 'dark' ? darkAlgorithm : defaultAlgorithm,
      }}
    >
      {children}
    </ConfigProvider>
  );
};
